@if (activeFilters$ | async; as activeFilters) {
  @if (activeFilters?.length) {
    <div class="perimeter-active-filters" (click)="openFiltersDialog()">
      <div class="first-filter">
        {{ activeFilters[0].label }} : 
        {{ activeFilters[0].values }}
      </div>
      @if (activeFilters.length > 1) {
        <div class="other-filters">
          +{{ activeFilters.length - 1 }} 
          @if (activeFilters.length - 1 > 1) {
            {{ "filters" | translate }}
          } @else {
            {{ "filter" | translate }}
          }
        </div>
      }
    </div>
  }
}
